define('adminUserGroupsListHeaderToolsView',[
  'app',
  'module',
  'underscore',
  'windows',
  'tableHeaderFieldView',
  'adminUserGroupsCreatePopupView',
  'template!adminUserGroupsListHeaderToolsView',
  'entities/admin/user_groups'
], function (
  App,
  Module,
  _,
  Windows,
  FieldView,
  CreatePopupView,
  Tpl
) {
  'use strict';

  Module.exports = FieldView.extend({
    template: Tpl,
    className: 'admin-user-groups-list-header-tools-view table-field-view',

    ui: {
      addButton: '.add'
    },

    events: {
      'click @ui.addButton': 'onAdd'
    },

    onAdd: function () {
      // Always re-read the flag from the server at click time. We don't trust
      // any cached value because the initial page-load fetch can race with
      // the first render.
      App.request('userGroups:canEdit').done(_.bind(function (canEdit) {
        if (canEdit !== true) {
          return;
        }
        App.userGroupsCanEdit = true;
        Windows.open({
          view: _.bind(function () {
            return new CreatePopupView({
              onConfirm: _.bind(function () {
                this.tableView.bodyView.fetch();
                this.tableView.footerView.fetch();
              }, this)
            });
          }, this),
          title: _.i18n('common.create'),
          width: 520,
          height: 560,
          modal: true
        });
      }, this));
    }
  });
});

